import { Navigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import { Loader } from "simplydo/react/ui/loader";

import api from "api";

import PageLoadError from "components/lib/PageLoadError";

export const DiscussionRedirect = () => {
  const discussionId = useParams<{ discussionId: string }>().discussionId || "";
  const [searchParams] = useSearchParams();

  const discussionQuery = useQuery(
    initUseQuery(api.discussions.get, [discussionId], {
      isEnabled: !!discussionId,
    }),
  );

  const forType = discussionQuery.data?.discussion?.forType || "";
  const forId = discussionQuery.data?.discussion?.forId || "";

  if (forType === "group") {
    return (
      <Navigate
        replace
        to={`/groups/${forId}/discussions/${discussionId}?${searchParams.toString()}`}
      />
    );
  }

  if (discussionQuery.isLoading) {
    return <Loader />;
  }

  return (
    <PageLoadError
      title="Discussion not found"
      message="The discussion you are looking for does not exist."
    />
  );
};
